@if (isLoading()) {
  <app-dots-loader></app-dots-loader>
} @else {
  <app-nav-header></app-nav-header>
  <div class="container">
    <div class="preface">
      <div class="headline">Scalable software for <i>growing</i> businesses</div>
      <div class="bottom">
        <div class="scroll-down" (click)="scrollToSection()">
          <div class="arrows"></div>
        </div>
      </div>
    </div>
  </div>
  <ul #section class="projects-list">
    @for (p of works(); track p.id) {
      <li [routerLink]="['/case-studies/',p.documentId]">
        <app-portfolio-card [project]="p"></app-portfolio-card>
      </li>
    }
  </ul>
  <div class="additional">
    <div class="text-center">Why partner with Capital Soft?</div>
    <app-statistics></app-statistics>
    <div class="call-to-form">
      <div class="title">Let’s turn your idea into a powerful product.</div>
      <button mat-flat-button class="btn" [routerLink]="['/']" fragment="contactus">Contact Us</button>
      <div id="social-icons">
        <ul>
          <li>
            <a href="https://www.linkedin.com/company/capitalsoft-armenia/" target="_blank">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </li>
          <li>
            <a href="mailto:info@capitalsoft.am" target="_blank">
              <i class="far fa-envelope"></i>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/capitalsoft.am/" target="_blank">
              <i class="fab fa-facebook-f"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
}
